import RemainingCustomerPackageDetailByBC from "./RemainingCustomerPackageDetailByBC";
import { useEffect, useState } from "react";
import RemainingCustomerPackageDetailFilter from "./RemainingCustomerPackageDetailFilter";
import { useAPIgetCustomer } from "../api/api-get-customer";
import { useParams } from "react-router-dom";
import RemainingPackageDetailList from "./RemainingPackageDetailList";

const RemainingCustomerPackageDetailMain = () => {
  const [onDataReady, setOnDataReady] = useState([]);
  const { id, product_name } = useParams();
  const {
    data,
    setData,
    error,
    setError,
    fetchData,
    filterValue,
    setFilterValue,
    loading,
  } = useAPIgetCustomer();

  useEffect(() => {
    fetchData({ id: id });
  }, [id]);

  useEffect(() => {
    fetchData({ id: id });
  }, [filterValue]);
  return (
    <div className="w-full col-center-start gap-4 p-4">
      <RemainingCustomerPackageDetailByBC
        onDataReady={setOnDataReady}
        id={id}
        product_name={product_name}
      />
      <RemainingCustomerPackageDetailFilter
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        loading={loading}
        BCList={onDataReady}
      />
      <RemainingPackageDetailList
        data={data}
        filterValue={filterValue}
        loading={loading}
        product_name={product_name}
      />
    </div>
  );
};

export default RemainingCustomerPackageDetailMain;
